(() => {
  const copy = {
    nl: { singles: 'Losse kaarten zoeken', products: 'Producten & accessoires zoeken', switchTitle: 'Zoek je een losse kaart?', switchBody: 'Gebruik de uitgebreide filters voor set, kaartnummer, taal en conditie.', openSingles: 'Open de zoeker voor losse kaarten', shopSwitch: 'Zoek boosterboxen, mappen, kaartbeschermers en accessoires' },
    en: { singles: 'Search single cards', products: 'Search products & accessories', switchTitle: 'Looking for a single card?', switchBody: 'Use the detailed filters for set, card number, language and condition.', openSingles: 'Open the Singles Finder', shopSwitch: 'Search booster boxes, binders, sleeves and accessories' },
    de: { singles: 'Einzelkarten suchen', products: 'Produkte & Zubehör suchen', switchTitle: 'Suchst du eine Einzelkarte?', switchBody: 'Nutze die detaillierten Filter für Set, Kartennummer, Sprache und Zustand.', openSingles: 'Einzelkarten-Suche öffnen', shopSwitch: 'Booster-Boxen, Binder, Hüllen und Zubehör suchen' },
    fr: { singles: 'Rechercher des cartes à l’unité', products: 'Rechercher des produits et accessoires', switchTitle: 'Vous cherchez une carte à l’unité ?', switchBody: 'Utilisez les filtres détaillés pour l’édition, le numéro, la langue et l’état.', openSingles: 'Ouvrir la recherche de cartes à l’unité', shopSwitch: 'Rechercher des boîtes de boosters, classeurs, pochettes et accessoires' },
    es: { singles: 'Buscar cartas sueltas', products: 'Buscar productos y accesorios', switchTitle: '¿Buscas una carta suelta?', switchBody: 'Usa los filtros detallados de set, número, idioma y estado.', openSingles: 'Abrir el buscador de cartas sueltas', shopSwitch: 'Buscar cajas, álbumes, fundas y accesorios' },
    it: { singles: 'Cerca carte singole', products: 'Cerca prodotti e accessori', switchTitle: 'Cerchi una carta singola?', switchBody: 'Usa i filtri dettagliati per set, numero, lingua e condizione.', openSingles: 'Apri la ricerca di carte singole', shopSwitch: 'Cerca booster box, raccoglitori, bustine protettive e accessori' },
  };
  const locale = String(document.documentElement.lang || 'nl').slice(0, 2).toLowerCase();
  const labels = copy[locale] || copy.nl;
  const routeRoot = window.Shopify?.routes?.root || '/';
  const localizedRoot = routeRoot.endsWith('/') ? routeRoot : `${routeRoot}/`;
  const previewParameters = ['preview_theme_id', 'preview_script_debug', '_fd', 'pb', '_ab', '_sc'];
  const productSearchExclusion = 'NOT product_type:Single NOT product_type:Singles';
  const productSearchExclusionPattern = /(?:^|\s)NOT\s+product_type:Single\s+NOT\s+product_type:Singles(?=\s|$)/gi;
  const explicitProductIconForms = new WeakSet();

  const cleanProductSearchQuery = (query) => String(query || '')
    .replace(productSearchExclusionPattern, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  const productSearchQuery = (query) => {
    const cleanQuery = cleanProductSearchQuery(query);
    return cleanQuery ? `${productSearchExclusion} ${cleanQuery}` : productSearchExclusion;
  };

  const preservePreview = (url) => {
    const current = new URL(window.location.href);
    for (const key of previewParameters) {
      const value = current.searchParams.get(key);
      if (value) url.searchParams.set(key, value);
    }
    return url;
  };

  document.querySelectorAll('form.lc-404-help__search').forEach((form) => {
    form.dataset.lcUnifiedSearch = '';
  });

  const translate = (scope = document) => {
    const elements = [...scope.querySelectorAll('[data-lc-i18n]')];
    if (scope.matches?.('[data-lc-i18n]')) elements.push(scope);
    elements.forEach((element) => {
      const value = labels[element.dataset.lcI18n];
      if (value) element.textContent = value;
    });
  };

  const preserveDestinationLinks = (scope = document) => {
    const links = [...scope.querySelectorAll('[data-lc-preserve-preview]')];
    if (scope.matches?.('[data-lc-preserve-preview]')) links.push(scope);
    for (const link of links) {
      const url = preservePreview(new URL(link.href, window.location.origin));
      link.href = `${url.pathname}${url.search}`;
    }
  };

  translate();
  preserveDestinationLinks();
  const updateShopSwitches = () => {
    const query = document.querySelector('[data-index-search]')?.value.trim() || '';
    document.querySelectorAll('[data-lc-shop-switch]').forEach((link) => {
      const url = new URL(`${localizedRoot}search`, window.location.origin);
      if (query) {
        url.searchParams.set('q', productSearchQuery(query));
      } else {
        url.searchParams.set('view', 'shop');
      }
      url.searchParams.set('type', 'product');
      url.searchParams.set('options[prefix]', 'last');
      preservePreview(url);
      link.href = `${url.pathname}${url.search}`;
    });
  };
  updateShopSwitches();
  document.addEventListener('input', (event) => {
    if (event.target.matches?.('[data-index-search]')) updateShopSwitches();
  });
  document.addEventListener('lichcards:singles:query-change', updateShopSwitches);
  document.addEventListener('click', (event) => {
    const productIcon = event.target.closest?.('[data-lc-search-icon]');
    if (
      productIcon?.form &&
      (event.detail > 0 || document.activeElement === productIcon)
    ) {
      explicitProductIconForms.add(productIcon.form);
    }
    if (event.target.closest?.('[data-lc-shop-switch]')) updateShopSwitches();
  }, true);
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest?.('form[data-lc-unified-search], form[data-lc-products-search]');
      if (!form) return;
      const explicitProductIcon = explicitProductIconForms.has(form);
      explicitProductIconForms.delete(form);
      const query = cleanProductSearchQuery(form.querySelector('input[name="q"]')?.value || '');
      if (!query) {
        event.preventDefault();
        return;
      }
      const explicitSingles = event.submitter?.matches('[data-lc-search-singles]');
      const explicitProducts =
        event.submitter?.matches('[data-lc-search-products]') || explicitProductIcon;
      const productsOnlyForm = form.matches('[data-lc-products-search]');
      const selectedPredictiveResult = form
        .closest('predictive-search')
        ?.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
      if (!explicitSingles && !explicitProducts && selectedPredictiveResult) return;

      if (!explicitSingles || explicitProducts || productsOnlyForm) {
        const url = preservePreview(new URL(`${localizedRoot}search`, window.location.origin));
        event.preventDefault();
        event.stopImmediatePropagation();
        url.searchParams.set('q', productSearchQuery(query));
        url.searchParams.set('type', 'product');
        url.searchParams.set('options[prefix]', 'last');
        window.location.assign(`${url.pathname}${url.search}`);
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
      const url = new URL(`${localizedRoot}pages/singles-search`, window.location.origin);
      url.searchParams.set('q', query);
      preservePreview(url);
      window.location.assign(`${url.pathname}${url.search}`);
    },
    true,
  );

  const currentProductSearchForm = document.querySelector('form[data-lc-products-search]');
  if (currentProductSearchForm) {
    const currentUrl = new URL(window.location.href);
    const currentType = currentUrl.searchParams.get('type');
    const currentQuery = currentUrl.searchParams.get('q') || '';
    const canonicalQuery = productSearchQuery(currentQuery);
    if (currentQuery && (!currentType || currentType === 'product') && (
      currentQuery.trim() !== canonicalQuery ||
      currentType !== 'product' ||
      currentUrl.searchParams.get('options[prefix]') !== 'last'
    )) {
      currentUrl.searchParams.set('q', canonicalQuery);
      currentUrl.searchParams.set('type', 'product');
      currentUrl.searchParams.set('options[prefix]', 'last');
      window.location.replace(`${currentUrl.pathname}${currentUrl.search}`);
      return;
    }
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches('[data-lc-i18n]') || node.querySelector('[data-lc-i18n]')) translate(node);
        if (node.matches('[data-lc-preserve-preview]') || node.querySelector('[data-lc-preserve-preview]')) {
          preserveDestinationLinks(node);
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
